<template>
  <div>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12">
        <label for="" style="margin-bottom: 15px;">{{
          $t("feedback.incidentReport.title")
        }}</label>
      </div>
      <div class="col-md-12" style="text-align: right;">
        <button
          v-if="
            feedbackStatus !== feedbackStatusEnum.DONE &&
              feedbackStatus !== feedbackStatusEnum.CANCELED
          "
          type="button"
          class="btn btn-info btn-sm extra-tools"
          @click="onOpenAddInput($event)"
        >
          <i class="glyphicon glyphicon-plus"></i>
          {{ $t("common.addnew") }}
        </button>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12">
        <b-table
          :items="maintenanceList"
          :fields="maintenanceFields"
          :tbody-tr-class="rowClass"
          class="mt-3 package-table"
          responsive
          outlined
        >
          <template #head()="scope">
            <div>{{ $t(scope.label) }}</div>
          </template>
          <template #cell(status)="row">
            {{ $t(getmaintenanceStatus(row.item.status)) }}
          </template>
        </b-table>
        <div
          v-if="maintenanceList.length > 0"
          class="box-footer clearfix"
          style="display:contents;"
        >
          <paginator
            :totalItem="paginateData.totalItem"
            :currentPage="paginateData.currentPage"
            :pageSize="paginateData.pageSize"
            :totalPage="paginateData.totalPage"
            @onpaginate="onPagination"
          />
        </div>
        <!-- <maintenance-modal
          ref="maintenanceModal"
          @callbackMaintenanceList="callbackMaintenance"
        /> -->
        <select-multiplate-asset-modal
          ref="selectMultiplateAssetIncidentModal"
          :modalTitle="`propertyMaintenance.addIncidentReport`"
          :isShowTitle="true"
          :isShowDescription="true"
          isShowPrice
          @emitAssetSelect="emitAssetSelectFunction"
        />
      </div>
    </div>
    <!--  -->
  </div>
</template>
<script>
import Paginator from "@/components/CustomPaginator.vue";
// import MaintenanceModal from "../Property/MaintenanceModal";
import SelectMultiplateAssetModal from "../Property/SelectMultiplateAssetModal";
import Enum from "../../../enum/enum";
import feedbackStatusEnum from "@/enum/feedbackStatusEnum";
import utils from "@/lib/utils";
import constantsData from "@/lib/constantsData";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    // MaintenanceModal,
    SelectMultiplateAssetModal,
    paginator: Paginator
  },
  props: {
    feedbackId: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    feedbackStatus: {
      type: Number,
      default: () => {
        return null;
      }
    }
  },
  data: () => ({
    maintenanceList: [],
    maintenanceFields: [
      {
        key: "nonumber",
        label: "common.nonumber",
        sortable: false,
        class: "text-center"
      },
      {
        key: "assetCode",
        label: "propertyMaintenance.assetCode",
        sortable: false
      },
      {
        key: "assetName",
        label: "property.asset.name",
        sortable: false
      },
      {
        key: "assetLocation",
        label: "property.asset.location",
        sortable: false
      },
      {
        key: "seriCode",
        label: "property.asset.seriCode",
        sortable: false
      },
      {
        key: "assetModel",
        label: "property.asset.model",
        sortable: false
      },
      {
        key: "activityPlanTitle",
        label: "propertyMaintenance.maintenanceTitle",
        sortable: false
      },
      {
        key: "typeOfMaintenance",
        label: "propertyMaintenance.typeOfMaintenance",
        sortable: false
      },
      {
        key: "assetStatus",
        label: "property.asset.status",
        sortable: false
      }
    ],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    maintenanceStatusList: constantsData.maintenanceStatusList,
    feedbackStatusEnum: feedbackStatusEnum,
    maintenanceTypeValue: null,
    assetIds: [],
    titleData: null,
    description: null,
    isLoading: false,
    priceData: null
  }),
  watch: {
    feedbackId: function() {
      if (this.feedbackId !== 0 && this.feedbackId !== null) {
        //
        this.getfeedbackStatus;
        this.getIncidentList(1);
      }
    },
    GET_ACTIVITY_PLAN_LIST_DATA: function() {
      let paginate = this.GET_ACTIVITY_PLAN_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      let data = this.GET_ACTIVITY_PLAN_LIST_DATA.results;
      this.maintenanceList = [];
      data.forEach((e, i) => {
        let assetId = e.asset_id;
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;
        let item = {
          id: e.id,
          assetId: assetId,
          nonumber: nonumber,
          assetCode: e.code,
          assetName: e.name,
          assetLocation: e.location,
          seriCode: e.seri_code,
          assetModel: e.asset_model,
          nextMaintainanceDate: utils.formatSqlDate(e.next_maintainance_date, null, "DD/MM/YYYY"),
          assetStatus: e.status,
          activityPlanTitle: e.title,
          typeOfMaintenance: e.maintenance_type_data.default,
          maintenanceTypeId: e.maintenance_type_data.id,
        };
        this.maintenanceList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACTIVITY_PLAN_LIST_DATA"
    ])
  },
  methods: {
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    rowClass: function(item, type) {
      if (!item || type !== "row") return;
      if (item.status === Enum.MaintenanceStatusEnum.MAINTENANCE_CANCELED) {
        return "description-width maintenance-cancel-class-bg";
      } else return "description-width";
    },
    onOpenAddInput: function(event) {
      event.preventDefault();
      // this.$refs.maintenanceModal.addNew(
      //   Enum.MaintenanceStatusEnum.MAINTENANCE_PLANNING,
      //   this.feedbackId
      // );
      this.$refs.selectMultiplateAssetIncidentModal.onSelectAsset(
        Enum.MaintenanceTypeEnum.INCIDENT,
        this.feedbackId
      );
    },
    getIncidentList: function(page) {
      let filter = {
        // id: this.feedbackId,
        params: {
          page: page,
          page_size: 10,
          feedbackId: this.feedbackId
        }
      };
      this.GET_ACTIVITY_PLAN_LIST(filter);
    },
    getmaintenanceStatus: function(value) {
      let index = this.maintenanceStatusList.findIndex(x => x.value === value);
      return index !== -1 ? this.maintenanceStatusList[index].text : "";
    },
    onPagination: function(data) {
      this.getIncidentList(data);
    },
    callbackMaintenance: function() {
      this.getIncidentList(this.paginateData.currentPage);
    },
    emitAssetSelectFunction: function(data) {
      let objKey = Object.keys(data);
      if (objKey.includes("assetList")) {
        let assetList = data.assetList;
        if (assetList.length === 0) {
          this.showError("propertyMaintenance.errorSelectAsset");
        } else {
          this.maintenanceTypeValue = Enum.MaintenanceTypeEnum.INCIDENT;
          this.assetIds = [];
          assetList.forEach(e => {
            this.assetIds.push(e.id);
          });
          this.titleData = data.title;
          this.description = data.description;
          if (objKey.includes("price")) {
            this.priceData = data.price;
          }
          this.onSaveAssetActivityPlan();
        }
      }
    },
    onSaveAssetActivityPlan: function() {
      let data = {
        assetIds: this.assetIds,
        maintenanceType: this.maintenanceTypeValue,
        title: this.titleData,
        description: this.description,
        price: this.priceData,
        feedbackId: this.feedbackId
      };
      this.POST_ASSET_LIST_ACTIVITY_PLAN(data).then(
        function() {
          this.isLoading = false;
          this.$refs.selectMultiplateAssetIncidentModal.onCloseModal()
          this.callbackMaintenance(this.paginateData.currentPage);
        }.bind(this)
      ).catch(
        function(error) {
          this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          this.isLoading = false;
        }.bind(this)
      );
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "GET_ACTIVITY_PLAN_LIST",
      "POST_ASSET_LIST_ACTIVITY_PLAN"
    ])
  },
  mounted() {
    if (this.feedbackId !== 0 && this.feedbackId !== null) {
      //
      this.getIncidentList(1);
    }
  }
};
</script>
<style lang="scss" scoped>
.table-responsive
  /deep/
  .b-table
  .description-width
  .description-content-width {
  width: 15%;
}
.table-responsive /deep/ .b-table .maintenance-cancel-class-bg {
  background: #f5c6cb;
}
</style>



// WEBPACK FOOTER //
// src/views/Case/IncidentReport.vue